import React from 'react';

export default function CardProductSkeleton( smallView = false ) {
    return (
        <div className="card card--bordered card--product">
            <div className="card__image loader--skeleton" style={{ height: '200px' }}></div>
            <div className="card-body">
                <div className="loader--skeleton" style={{ height: '20px', width: '80%', marginBottom: '8px' }}></div>
                <div className="loader--skeleton" style={{ height: '14px', width: '50%', marginBottom: '16px' }}></div>
                <div className="mt-auto">
                    <div className={`d-flex ${ smallView ? 'flex-column' : 'justify-content-between align-items-center' } gap-4 mt-5`}>
                        <div className="price line-height-1">
                            <div className="loader--skeleton" style={{ height: '18px', width: '70px', marginBottom: '4px' }}></div>
                            <div className="loader--skeleton" style={{ height: '12px', width: '100px' }}></div>
                        </div>
                        <div className="card__button">
                            <div className="loader--skeleton" style={{ height: '38px', width: '120px', borderRadius: '4px' }}></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}